import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Image Library")
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "order-item-artwork-custom p-1 order-artwork h-100" }
const _hoisted_6 = { class: "flex items-center pl-5" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_SlotError = _resolveComponent("SlotError")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_EditRowButton = _resolveComponent("EditRowButton")!
  const _component_DeleteRowButton = _resolveComponent("DeleteRowButton")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CreateOrUpdate = _resolveComponent("CreateOrUpdate")!
  const _component_upload_multi_files = _resolveComponent("upload-multi-files")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionCreate: _ctx.createImageLibrary,
    onActionExport: _ctx.exportImageLibrary,
    onActionOtherButton1: _ctx.uploadMultipleFiles
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "mt-3 flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_table, {
                onOnFilterCallback: _ctx.onFilterCallback,
                placeholder: "Search"
              }, null, 8, ["onOnFilterCallback"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_table, {
                data: _ctx.documents,
                stripe: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: index,
                      label: column.title,
                      props: column.dataIndex,
                      "min-width": column.minWidth,
                      align: column.align
                    }, {
                      default: _withCtx((scope) => [
                        (column.dataIndex == 'title')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row[column.dataIndex]), 1))
                          : _createCommentVNode("", true),
                        (column.dataIndex == 'filePath')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_el_image, {
                                    style: {"width":"120px","height":"auto"},
                                    class: "border avatar-uploader",
                                    src: 
                          _ctx.imageUrl(scope.row[column.dataIndex], true, 200, 200)
                        ,
                                    "preview-src-list": [
                          _ctx.imageUrl(scope.row[column.dataIndex]),
                        ],
                                    title: "Click to preview"
                                  }, {
                                    error: _withCtx(() => [
                                      _createVNode(_component_SlotError, {
                                        urlError: scope.row[column.dataIndex]
                                      }, null, 8, ["urlError"])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    circle: "",
                                    title: "Copy to clipboard",
                                    onClick: ($event: any) => (_ctx.copyToClipboardV2(_ctx.imageUrl(scope.row.filePath)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CopyDocument)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (column.dataIndex == 'contentType')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row[column.dataIndex]), 1))
                          : _createCommentVNode("", true),
                        (column.dataIndex == 'createdAt')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.formatTime(scope.row[column.dataIndex])), 1))
                          : _createCommentVNode("", true),
                        (column.dataIndex == 'action')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                              _createVNode(_component_EditRowButton, {
                                onClick: ($event: any) => (_ctx.updateImageLibrary(scope.row))
                              }, null, 8, ["onClick"]),
                              (_ctx.isManager)
                                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                    key: 0,
                                    title: "Are you sure to delete this?",
                                    onConfirm: ($event: any) => (_ctx.onDelete(scope.row))
                                  }, {
                                    reference: _withCtx(() => [
                                      _createVNode(_component_DeleteRowButton)
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["label", "props", "min-width", "align"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data"]), [
                [_directive_loading, _ctx.isLoading]
              ]),
              _createVNode(_component_pagination, {
                total: _ctx.total,
                pagination: _ctx.params.page,
                "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.page) = $event)),
                limit: _ctx.params.limit,
                "onUpdate:limit": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.limit) = $event))
              }, null, 8, ["total", "pagination", "limit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CreateOrUpdate, {
        ref: "uploadLibraryImageDialog",
        onOnAfterCreate: _ctx.onAfterCreate
      }, null, 8, ["onOnAfterCreate"]),
      _createVNode(_component_upload_multi_files, {
        ref: "uploadMultiFilesDialog",
        title: "Upload Multiple Files",
        onOnAfterUploadImages: _ctx.onAfterUploadImages
      }, null, 8, ["onOnAfterUploadImages"])
    ]),
    _: 1
  }, 16, ["onActionCreate", "onActionExport", "onActionOtherButton1"]))
}